import script from "./storView.vue?vue&type=script&setup=true&lang=js"
export * from "./storView.vue?vue&type=script&setup=true&lang=js"

import "./storView.vue?vue&type=style&index=0&id=74cb3392&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74cb3392"]])

export default __exports__